var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"px-3 py-1 rounded-full font-semibold text-sm capitalize",class:_vm.isTestnet
      ? 'bg-papaya-whip text-reddish-orange'
      : 'bg-apple-green text-ocean-green'},[_vm._v(" "+_vm._s(_vm.network)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }